import { render, staticRenderFns } from "./OpenAILeftSidebar.vue?vue&type=template&id=84404754&scoped=true&"
import script from "./OpenAILeftSidebar.vue?vue&type=script&lang=js&"
export * from "./OpenAILeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OpenAILeftSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OpenAILeftSidebar.vue?vue&type=style&index=1&id=84404754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84404754",
  null
  
)

export default component.exports